// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F74ub","right":"styles_right__34l61"};